import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary, OptionDefinition } from './SortOptionDefinitions';
import { Messages } from '../../../codegen/Localize';

export const defaultCollectionSort = [Order.asc(OrderKeys.name)];

const visibilityOption: OptionDefinition = {
  id: 'visibility',
  getMenuItemDisplayValue: Messages.collectionVisibilityColumn,
  subSortOptions: {
    'desc': {
      id: 'visibility.desc',
      field: OrderKeys.visibility,
      getMenuItemDisplayValue: Messages.sortyByPublicVisibilty,
      getButtonDisplayValue: Messages.sortyByPublicVisibiltyButton,
      ascending: false,
      toOrderClauseArray: () => [Order.desc(OrderKeys.visibility)]
    },
    'asc': {
      id: 'visibility.asc',
      field: OrderKeys.visibility,
      getMenuItemDisplayValue: Messages.sortyByPrivateVisibilty,
      getButtonDisplayValue: Messages.sortyByPrivateVisibiltyButton,
      ascending: true,
      toOrderClauseArray: () => [Order.asc(OrderKeys.visibility)]
    }
  }
};

export const collectionsSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  // TFSID:1076018: 'itemCount': createNonDisplayOptionDefinition('itemCount', OrderKeys.itemCount),
  'visibility': visibilityOption,
  'createdAt': SortOptions.createdAt,
  'updatedAt': SortOptions.updated,
};
